import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminLoginMutation } from '../../../store/api/adminApi';
import { setCredentials } from '../../../store/slices/authSlice';
import { useAppDispatch } from '../../../hooks/redux';
import { showSuccess, showError } from '../../../utils/toast';
import logo from '../../../assets/images/logo.png';

const AdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [login, { isLoading, error }] = useAdminLoginMutation();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const result = await login(formData).unwrap();
      if (result.status && result.data) {
        dispatch(setCredentials({
          token: result.data.token,
          user: result.data.admin,
          userType: 'admin',
          permissions: result.data.permissions ?? [],
        }));
        showSuccess(result.message || 'Login successful!');
        navigate('/admin/dashboard');
      } else {
        showError(result?.message || 'Login failed. Please check your credentials.');
      }
    } catch (err: any) {
      const errorMessage = err?.data?.message || err?.message || 'Login failed. Please check your credentials.';
      showError(errorMessage);
    }
  };

  return (
    <div id="kt_body" className="app-blank app-blank" style={{ height: '100vh', overflow: 'hidden' }}>
        <div className="d-flex flex-column flex-root" id="kt_app_root" style={{ height: '100vh', overflow: 'hidden' }}>
          <div className="d-flex flex-column flex-lg-row flex-column-fluid" style={{ height: '100vh', overflow: 'hidden' }}>
            <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1" style={{ height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div className="d-flex flex-center flex-column flex-lg-row-fluid" style={{ flex: 1, justifyContent: 'center' }}>
                <div className="w-lg-500px">
                  <form className="form w-100" onSubmit={handleSubmit} id="kt_sign_in_form">
                    <div className="text-center mb-11">
                      <h1 className="text-dark fw-bolder mb-3">Admin Login</h1>
                      <div className="text-gray-500 fw-semibold fs-6">Welcome! Login to your account</div>
                    </div>
                    
                    
                    <div className="fv-row mb-8">
                      <label className="form-label fw-semibold fs-6 mb-2">Email</label>
                      <input
                        type="email"
                        placeholder="Email"
                        name="email"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        autoComplete="off"
                        className="form-control bg-transparent"
                        required
                      />
                    </div>
                    
                    <div className="fv-row mb-3">
                      <div className="form-group">
                        <label className="form-label fw-semibold fs-6 mb-2">Password</label>
                        <div className="input-group" id="show_hide_password">
                          <input
                            className="form-control bg-transparent"
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Password"
                            name="password"
                            value={formData.password}
                            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                            autoComplete="off"
                            required
                          />
                          <div className="input-group-addon bg-gray-100 p-4" style={{ cursor: 'pointer' }}>
                            <a href="#" onClick={(e) => { e.preventDefault(); setShowPassword(!showPassword); }} style={{ textDecoration: 'none' }}>
                              <i className={`fa ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} aria-hidden="true"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                      <div></div>
                      <a href="#" className="text-base" onClick={(e) => e.preventDefault()}>Forgot Password ?</a>
                    </div>
                    
                    <div className="d-grid mb-10">
                      <button
                        type="submit"
                        className="btn btn-base bg-gradient-right"
                        disabled={isLoading}
                      >
                        <span className="indicator-label">Sign In</span>
                        {isLoading && (
                          <span className="indicator-progress">
                            Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              
              <div className="d-flex flex-center flex-wrap px-5">
                <div className="d-flex fw-semibold text-base fs-base">
                  <a href="/" className="px-5 text-base" onClick={(e) => e.preventDefault()}>Copyright By Fesilah @{new Date().getFullYear()}</a>
                </div>
              </div>
            </div>
            
            <div className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-right order-1 order-lg-2 bg-light" style={{ backgroundImage: 'url(/media/bg5-dark.webp)', height: '100vh', overflow: 'hidden' }}>
              <div className="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100">
                <a href="/home" className="mb-0 mb-lg-12" onClick={(e) => e.preventDefault()}>
                  <img alt="Logo" src={logo} className="h-125px h-lg-150px" />
                </a>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default AdminLogin;
